import {
  LayoutTemplate,
  FileText,
  Users,
  Banknote,
  ClipboardList,
  PenLine,
  FileStack,
  Type,
  Table2,
  Image,
} from 'lucide-react';
import { BlockType } from '@/types';

/** Icoon per paginatype, in de paginalijst en in Pagina toevoegen. */
export const BLOCK_ICON: Record<string, React.ComponentType<{ className?: string }>> = {
  [BlockType.COVER]: LayoutTemplate,
  [BlockType.CONTENT_PAGE]: FileText,
  [BlockType.TEAM]: Users,
  [BlockType.INVESTMENT]: Banknote,
  [BlockType.PLAN_VAN_AANPAK]: ClipboardList,
  [BlockType.SIGNATURE_PAGE]: PenLine,
  [BlockType.FOOTER]: FileStack,
  [BlockType.TEXT]: Type,
  [BlockType.TABLE]: Table2,
  [BlockType.IMAGE]: Image,
};
